<template>
  <div>
    <div class="table-header mt-16">
      <div class="flex items-center">
        <div class="table__search-input-wrapper">
          <span class="pr-2 opacity-50"><search-icon /> </span>
          <input
            type="text"
            class="table__search-input"
            placeholder="Search..."
            v-model="queryString"
          />

          <svg
            width="14"
            height="13"
            viewBox="0 0 14 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 1.99992C0 1.35559 0.522334 0.833252 1.16667 0.833252H12.8333C13.4777 0.833252 14 1.35559 14 1.99992C14 2.64425 13.4777 3.16659 12.8333 3.16659H1.16667C0.522334 3.16659 0 2.64425 0 1.99992Z"
              fill="#10233E"
            />
            <path
              d="M2.33333 6.66658C2.33333 6.02225 2.85567 5.49992 3.5 5.49992H10.5C11.1443 5.49992 11.6667 6.02225 11.6667 6.66658C11.6667 7.31092 11.1443 7.83325 10.5 7.83325H3.5C2.85567 7.83325 2.33333 7.31092 2.33333 6.66658Z"
              fill="#10233E"
            />
            <path
              d="M5.83333 10.1666C5.189 10.1666 4.66667 10.6889 4.66667 11.3333C4.66667 11.9776 5.189 12.4999 5.83333 12.4999H8.16667C8.811 12.4999 9.33333 11.9776 9.33333 11.3333C9.33333 10.6889 8.811 10.1666 8.16667 10.1666H5.83333Z"
              fill="#10233E"
            />
          </svg>
        </div>
      </div>

      <div class="flex items-center justify-center">
        <!-- {{ selectedContacts }} -->
        <bulk-action class="mr-8" :display="isBulkAction">
          <p class="pb-2" @click="isBlacklistContactModal = true">Blackist</p>
          <p class="pb-2" @click="isLoyaltyGroupModal = true">Add to Loyalty</p>
        </bulk-action>
        <div class="relative" tabindex="-1" @blur="showCreateoptions = false">
          <div
            class="rounded create-button py-2 flex justify-center items-center cursor-pointer"
            @click="showCreateOptions = !showCreateOptions"
          >
            <p>Create</p>
            <span class="pl-2"
              ><svg
                width="10"
                height="5"
                viewBox="0 0 10 5"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0 0L5 5L10 0H0Z" fill="white" />
              </svg>
            </span>
          </div>
          <div class="create-options rounded" v-if="showCreateOptions">
            <p
              class="py-1 font-semibold"
              @click="$router.push({ name: 'CustomerRegistration' })"
            >
              Create New
            </p>
            <p v-if="show"
              class="py-1 font-semibold "
              @click="$router.push({ name: 'ImportContacts' })"
            >
              Import Details
            </p>
          </div>
        </div>
        <div>
          <button
            class="border-2 border-darkBlue rounded py-1 px-3 font-semibold ml-4"
            @click="isExportModal = true"
          >
            Export Register
          </button>
        </div>
      </div>
    </div>

    <!-- <button @click="setScrollPosition">Set scroll</button> -->
    <div class="table-wrapper" id="table-wrapper">
      <table class="custom-table responsive-table">
        <thead>
          <tr>
            <th>
              <base-checkbox v-model="shouldSelectAllContacts" />
            </th>
            <th>CUSTOMER NAME</th>
            <th>PROFILE NAME</th>
            <th>MULEEX ID</th>
            <th>BILLING ADDRESS</th>
            <th>CONTACT PERSON</th>
            <th>REGISTERED BY</th>
            <th>REG. CHANNEL</th>
            <th class="relative" tabindex="-1">
              <span class="cursor-pointer">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g opacity="0.7">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M4 0.130371C5.86384 0.130371 7.42994 1.46057 7.87398 3.26081H16V5.34776H7.87398C7.42994 7.148 5.86384 8.4782 4 8.4782C1.79086 8.4782 0 6.60947 0 4.30428C0 1.9991 1.79086 0.130371 4 0.130371ZM4 6.39124C5.10457 6.39124 6 5.45688 6 4.30428C6 3.15169 5.10457 2.21733 4 2.21733C2.89543 2.21733 2 3.15169 2 4.30428C2 5.45688 2.89543 6.39124 4 6.39124Z"
                      fill="#383F51"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M14 17.8695C12.1362 17.8695 10.5701 16.5393 10.126 14.7391H2V12.6521H10.126C10.5701 10.8519 12.1362 9.52168 14 9.52168C16.2091 9.52168 18 11.3904 18 13.6956C18 16.0008 16.2091 17.8695 14 17.8695ZM14 15.7825C15.1046 15.7825 16 14.8482 16 13.6956C16 12.543 15.1046 11.6086 14 11.6086C12.8954 11.6086 12 12.543 12 13.6956C12 14.8482 12.8954 15.7825 14 15.7825Z"
                      fill="#383F51"
                    />
                  </g></svg
              ></span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="contact in filteredContacts"
            :key="contact.id"
            class="cursor-pointer"
          >
            <!-- @click="viewContactProfile(contact.id)" -->
            <td>
              <base-checkbox :value="contact.id" v-model="selectedContacts" />
            </td>
            <td @click="viewContactProfile(contact.id)">{{ contact.name }}</td>
            <td>On-Demand</td>
            <td>{{ contact.code }}</td>
            <td>{{ contact.address }}</td>
            <td>
              {{ contact.contactPerson ? contact.contactPerson : contact.name }}
            </td>
            <td>Self</td>
            <td>MuleEx</td>
            <td class="relative" tabindex="-1" @blur="selectedRowId = null">
              <span
                @click="
                  selectedRowId
                    ? (selectedRowId = null)
                    : (selectedRowId = contact.id)
                "
                ><vertical-ellipsis
              /></span>
              <action-popup width="w-48" v-if="selectedRowId == contact.id">
                <div>
                  <p
                    class="py-1"
                    @click="
                      (selectedContact = contact),
                        (isBlacklistContactModal = true)
                    "
                  >
                    Blacklist this Contact
                  </p>
                  <p
                    class="py-1"
                    @click="
                      (selectedContact = contact), (isLoyaltyGroupModal = true)
                    "
                  >
                    Add to Loyalty Scheme
                  </p>
                </div>
              </action-popup>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div
      v-if="!contacts.length && !loading"
      class="bg-white w-100 flex justify-center flex-col items-center p-5"
    >
      <empty-table-icon />
      <p class="font-semibold pt-3">
        Looks like you have not registered anyone yet.!
      </p>
      <p class="text-sm py-3">
        Add a new customer manually or import their details with the options
        below.
      </p>
      <div class="flex justify-between  pb-5">
        <p
          class="cursor-pointer text-primary-blue"
          @click="$router.push({ name: 'CustomerRegistration' })"
        >
          Create New
        </p>
        <p
          class="cursor-pointer pl-12 text-primary-blue"
          @click="$router.push({ name: 'ImportContacts' })"
        >
          Import Customer Details
        </p>
      </div>
    </div>
    <loader v-if="loading" />
    <pagination-control />

    <!-- Modal -->
    <loyalty-group-modal
      :show-modal="isLoyaltyGroupModal"
      @close-modal="isLoyaltyGroupModal = false"
      :contact="selectedContact"
      :contactIds="selectedContacts"
    />
    <blacklist-contact-modal
      v-if="isBlacklistContactModal"
      :show-modal="isBlacklistContactModal"
      @close-modal="isBlacklistContactModal = false"
      @contact-blacklisted="(selectedContacts = []), getAllContacts()"
      :contact="selectedContact"
      :contactIds="selectedContacts"
    />
    <customer-id-modal
      :show-modal="isCustomerIdModal"
      @close-modal="isCustomerIdModal = false"
    />
    <loyalty-scheme-modal
      :show-modal="isLoyaltySchemeModal"
      @close-modal="isLoyaltySchemeModal = false"
    />
    <export-modal
      :show-modal="isExportModal"
      @close-modal="isExportModal = false"
    />
    <!-- Modal -->
  </div>
</template>

<script>
import PaginationControl from "@/components/UI/NewPagination";
import LoyaltyGroupModal from "./Modals/AddToLoyaltyGroup";
import BlacklistContactModal from "./Modals/BlacklistContact";
import CustomerIdModal from "./Modals/SetupCustomerIdFormat";
import LoyaltySchemeModal from "./Modals/CreateLoyaltyScheme";
import ExportModal from "../Modals/ExportContacts.vue";

import FileDownload from "js-file-download";
// var fileDownload = require('js-file-download');

export default {
  components: {
    PaginationControl,
    LoyaltyGroupModal,
    BlacklistContactModal,
    CustomerIdModal,
    LoyaltySchemeModal,
    ExportModal,
  },
  data() {
    return {
      contacts: [],
      showCreateOptions: false,
      loading: true,
      isLoyaltyGroupModal: false,
      isBlacklistContactModal: false,
      isCustomerIdModal: false,
      isLoyaltySchemeModal: false,
      selectedRowId: null,
      selectedContact: {},
      queryString: "",
      // isBulkAction: false,
      selectedContacts: [],
      shouldSelectAllContacts: false,
      isExportModal: false,
    };
  },
  computed: {
    filteredContacts() {
      return this.filterArray(this.contacts, this.queryString);
    },
    isBulkAction() {
      return this.selectedContacts.length ? true : false;
    },
  },
  watch: {
    shouldSelectAllContacts(val) {
      if (val) {
        this.contacts.forEach((contact) => {
          this.selectedContacts.push(contact.id);
        });
      } else {
        this.selectedContacts = [];
      }
    },
  },
  mounted() {
    this.getAllContacts();
  },
  methods: {
    async getAllContacts() {
      this.loading = true;
      try {
        const response = await this.$_getAllContacts();
        console.log(response);
        this.contacts = response.data.contacts;
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false;
    },
    viewContactProfile(contactId) {
      localStorage.setItem("customerId", contactId);
      this.$router.push({ name: "CustomerProfile" });
    },
    async exportContacts() {
      try {
        const response = await this.$_downloadContact();
        console.log(response);
        FileDownload(response.data, "contacts.csv");
      } catch (error) {
        this.handleError(error);
      }
    },
    selectContact(contactId) {
      this.selectedContacts.push(contactId);
    },
    removeContact(contactId) {
      let contactIdIndex = this.selectedContacts.indexOf(contactId);
      this.selectedContacts.splice(contactIdIndex, 1);
    },
    selectAllContacts() {
      this.contacts.forEach((contact) => {
        this.selectedContacts.push(contact.id);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.table__search-input-wrapper {
  background: #f7fafd;
  width: 20rem;
  border-radius: 5px;
}
.custom-table,
.table-wrapper {
  margin-bottom: 0;
}
th {
  color: #707684;
  font-size: 0.8rem;
  padding: 0.5rem;
}
td {
  background: #ffffff;
  color: var(--primaryblue);
  font-weight: 500;
  border-radius: 2px;
  padding: 1rem 0.5rem;
  vertical-align: top;

  span {
    display: block;
  }
  span:last-of-type {
    font-weight: normal;
    color: #10233e;
    opacity: 0.6;
    padding-top: 0.25rem;
    font-size: 0.8rem;
  }
}
.checkbox {
  display: initial;
  width: 1rem;
  height: 1rem;
}
table {
  border-collapse: separate;
  border-spacing: 0 0.5rem;
}

.create-options {
  position: absolute;
  cursor: pointer;
  top: 3rem;
  width: 10rem;
  background: #ffffff;
  font-size: 0.9rem;
  padding: 0.25rem;
}
.create-button {
  width: 10rem;
  background: #10233e;
  color: #ffffff;
  text-align: center;
}
</style>
